const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const BattleConfig = require('../../../constants/BattleConfig');
const { logError } = require('../../logger');

const MultiShot = function (battleState) {
  this.handle = 'multi_shot';
  this.physical = true;
  this.bow = true;
  this.harm = true;
  this.ranged = true;

  this.eventEmitter = new EventEmitter();
  this.standardStrike = new StandardStrike(this, battleState);

  this.isLegal = function (actor, victim) {
    return victim.unit;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    try {
      var ability = BattleCalc.getEquippedAbility(actor, this.handle);
      var victims = [victim];

      var targets = getTargets();
      var charges = ability.charges;

      while (targets.length && charges) {
        var chance = Math.floor(Math.random() * targets.length);

        victims.push(targets.splice(chance, 1)[0]);
        --charges;
      }

      const result = { phase: 'fire_arrows' };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim.uid;
      result.victimIds = [];
      // result.allPieces = battleState.allPieces;

      for (var i = 0; i < victims.length; ++i) {
        result.victimIds.push(victims[i].uid);
      }

      this.eventEmitter.emit('result', result);

      setTimeout(() => {
        try {
          const result = {
            abilityHandle: this.handle,
            phase: 'strikes',
            strikes: [],
          };

          for (var i = 0; i < victims.length; ++i) {
            result.strikes.push(
              this.standardStrike.execute(
                actor,
                victims[i],
                ability.damage,
                true
              )
            );
          }

          this.eventEmitter.emit('result', result);
        } catch (err) {
          logError(err, {
            module: 'MultiShot',
            func: 'execute(timeout)',
            actor,
            victim,
          });
        }
      }, BattleCalc.projectileTime(BattleConfig.ARROW_SPEED, actor, victim) + 750);
    } catch (err) {
      logError(err, {
        module: 'MultiShot',
        func: 'execute',
        actor,
        victim,
      });
    }

    function getTargets() {
      var targets = [];

      for (var uid in battleState.allUnits) {
        var unit = battleState.allUnits[uid];
        if (
          unit.uid !== actor.uid &&
          unit.uid !== victim.uid &&
          unit.team !== actor.team &&
          BattleCalc.boardDistance(unit, victim) <= 2 &&
          !BattleCalc.adjacent(unit, actor)
        ) {
          targets.push(unit);
        }
      }

      return targets;
    }
  };
};
module.exports = MultiShot;
